import { ComponentType, lazy, LazyExoticComponent } from 'react';

import { TModalKey } from '@/store/types/modals.types';

export const DictionnaryModals: Record<TModalKey, LazyExoticComponent<ComponentType<{}>>> = {
  passwordModal: lazy(() => import('@/features/user/components/sendForgotPassword/ForgotPasswordModal')),
  kycDocumentReviewModal: lazy(() => import('@/features/kyc/components/modals/KycDocumentReviewModal')),
  kycDocumentDetailModal: lazy(() => import('@/features/kyc/components/modals/KycDocumentDetailModal')),
  kycDocumentDeleteModal: lazy(() => import('@/features/kyc/components/modals/KycDocumentDeleteModal')),
  viewScteBeneficiaryModal: lazy(() => import('@/features/beneficiaries/components/scte/ViewScteBeneficiaryModal')),
  editScteBeneficiaryModal: lazy(() => import('@/features/beneficiaries/components/scte/EditScteBeneficiaryModal')),
  viewB2bB2cBeneficiaryModal: lazy(
    () => import('@/features/beneficiaries/components/b2bB2c/ViewB2bB2cBeneficiaryModal'),
  ),
  editB2bBeneficiaryModal: lazy(() => import('@/features/beneficiaries/components/b2bB2c/EditB2bBeneficiaryModal')),
  editB2cBeneficiaryModal: lazy(() => import('@/features/beneficiaries/components/b2bB2c/EditB2cBeneficiaryModal')),
  onboardingConfigURLModal: lazy(() => import('@/pages/admin/configuration/UpdateOnboardingConfigModal')),
  configPasswordModal: lazy(() => import('@/pages/admin/configuration/ConfigPasswordModal')),
  templatesVariablesModal: lazy(() => import('@/pages/admin/template/TemplateVariablesModal')),
  addWebhookModal: lazy(() =>
    import('@/features/webhooks/components/AddWebhookModal').then((module) => ({ default: module.AddWebhookModal })),
  ),
  modifyWebhookModal: lazy(() => import('@/features/webhooks/components/ModifyWebhookModal')),
  restrictionsPredefModal: lazy(() => import('@/pages/admin/restrictionGroup/RestrictionGroupFormModal')),
  restrictionGroupUploadMetadata: lazy(() =>
    import('@/pages/admin/restrictionGroup/RestrictionGroupUploadMetadataModal').then((module) => ({
      default: module.RestrictionGroupUploadMetadataModal,
    })),
  ),
  addRestrictionGroup: lazy(() => import('@/pages/admin/restrictionGroup/AddRestrictionInGroupModal')),
  editRestrictionModal: lazy(() =>
    import('@/pages/admin/restrictionGroup/parts/EditionMetadataModal').then((module) => ({
      default: module.EditionMetadataModal,
    })),
  ),
  bulkCardRestrictionModal: lazy(
    () => import('@/features/cards/components/bulkCardCreation/BulkCardRestrictionsModal'),
  ),
  bulkdCardLimnitModal: lazy(() => import('@/features/cards/components/bulkCardCreation/BulkCardLimitsModal')),
  detailDialogBulk: lazy(() => import('@/features/cards/components/bulkCardCreation/DetailDialog')),
  paymentCardSettingsModal: lazy(() => import('@/features/cards/components/CardSettings/PaymentCardSettingsModal')),
  walletOperationDetailModal: lazy(
    () => import('@/features/wallets/components/WalletOperations/detail/OperationDetailModal'),
  ),
  downloadOperationsModal: lazy(
    () => import('@/features/wallets/components/DownloadOperations/DownloadOperationsModal'),
  ),
  p2pTransferModal: lazy(() => import('@/features/P2PTransfer/components/P2PTransferModal')),
  payoutModal: lazy(() => import('@/features/payouts/components/PayoutModal')),
  addWalletModal: lazy(() => import('@/features/wallets/components/AddWallet/AddWalletModal')),
  kycStatusHistoryModal: lazy(() => import('@/features/kyc/components/modals/KycStatusHistoryModal')),
  createBeneficiaryModal: lazy(() => import('@/features/beneficiaries/components/AddBeneficiary/AddBeneficiaryModal')),
  additionalVigilanceDetailModal: lazy(() => import('@/features/kyc/components/modals/AdditionalVigilanceDetailModal')),
  kycDocumentUploadModal: lazy(() => import('@/features/kyc/components/modals/KycDocumentUploadModal')),
  walletStatementModal: lazy(() => import('@/features/wallets/components/WalletStatementModal')),
  walletEditionModal: lazy(() => import('@/features/wallets/components/WalletEditionModal')),
  walletDetailModal: lazy(() => import('@/features/wallets/components/WalletDetailsModal')),
  createDashboardUserModal: lazy(() => import('@/features/dashboard-users/components/create/CreateDashboardUserModal')),
  dashboardUserUnblockModal: lazy(() => import('@/features/dashboard-users/components/DashboardUserUnblockModal')),
  dashboardUserRemoveModal: lazy(() => import('@/features/dashboard-users/components/DashboardUserRemoveModal')),
  secureSCAModal: lazy(() => import('@/features/sca/components/SecureSCAModal')),
  createUserDiscardModal: lazy(() => import('@/features/user/components/CreateUser/layout/PreventModal')),
  selectCompanyModal: lazy(() => import('@/features/user/components/CreateUser/SelectCompanyModal')),
  supportUserReviewModal: lazy(() => import('@/features/dashboard-users/components/SupportUserReviewModal')),
  supportUserConfirmModal: lazy(() => import('@/features/dashboard-users/components/SupportUserConfirmModal')),
  sctrSimulationModal: lazy(() => import('@/features/wallets/components/SctrSimulationModal')),
  operationSimulationModal: lazy(() => import('@/features/wallets/components/OperationSimulationModal')),
  transactionSimulationModal: lazy(() => import('@/features/cards/components/TransactionSimulationModal')),
  cardUnitCreationModal: lazy(() => import('@/features/cards/components/CardUnitCreationModal')),
  mainInformationEditionModal: lazy(
    () => import('@/features/user/components/tabs/overview/MainInformationEditionModal'),
  ),
  auth2FaCreationModal: lazy(() => import('@/features/2fa/components/Auth2FaCreationModal')),
  accessExpirationModal: lazy(
    () => import('@/features/dashboard-users/components/DashboardUserStatus/accessExpirationModal'),
  ),
  changeOwnPasswordModal: lazy(
    () => import('@/features/dashboard-users/components/changePassword/ChangeOwnPasswordModal'),
  ),
  changeDashboardUserPasswordModal: lazy(
    () => import('@/features/dashboard-users/components/changePassword/ChangeDashboardUserPasswordModal'),
  ),
  samlKeyModal: lazy(() => import('@/features/dashboard-users/components/manage/SAMLKeyModal')),
  confirmationReset2faModal: lazy(
    () => import('@/features/dashboard-users/components/manage/ConfirmationReset2faModal'),
  ),
  suspendDashboardUserModal: lazy(() => import('@/features/dashboard-users/components/SuspendDashboardUserModal')),
  restoreDashboardUserAccessModal: lazy(
    () => import('@/features/dashboard-users/components/RestoreDashboardUserAccessModal'),
  ),
};
